(() => {
  angular
    .module('gm.common.directives')
    .directive('gmDragAndDrop', gmDragAndDropDirective);

  function gmDragAndDropDirective() {
    'ngInject';

    return {
      restrict: 'E',
      require: 'ngModel',
      replace: true,
      templateUrl: 'modules/common/directives/drag-and-drop/drag-and-drop.html',

      link(scope, _element, _attrs, ctrl) {
        scope.$sc = scope;
        scope.document = null;

        scope.fileTypes = '.pdf,.png,.gif,.jpg,.jpeg';
        scope.maxSize = '8000000';
        scope.resize = {
          width: 1280,
          height: 960,
          quality: 0.8,
          type: 'image/jpeg',
          centerCrop: false,
        };

        scope.resizeCondition = (width, height) => (scope.resize.width < width
          || scope.resize.height < height);

        scope.$watch('document', doc => ctrl.$setViewValue(doc));
        scope.$watch(() => ctrl.$viewValue, (doc) => { scope.document = doc; });
      }
    };
  }
})();
